export const BUSINESS = {
  name: 'One Stop Auto Collision',
  nameKorean: '\uc6d0\uc2a4\ud0d1 \ubc14\ub514\uc0f5',
  phone: '+14082431440',
  phoneFormatted: '(408) 243-1440',
  address: {
    street: '1486 Jefferson St',
    city: 'Santa Clara',
    state: 'CA',
    zip: '95050',
    full: '1486 Jefferson St, Santa Clara, CA 95050',
  },
  hours: {
    weekdays: 'Mon-Fri: 8AM - 6PM',
    saturday: 'Sat: 9AM - 12PM',
    sunday: 'Sun: Closed',
  },
  email: 'Osacollision@Gmail.Com',
  website: 'https://onestopcollision.com',
  googleMapsUrl: 'https://maps.app.goo.gl/CNkfxSCW2BPSZrYt8',
  yelpUrl: 'https://www.yelp.com/biz/one-stop-auto-collision-santa-clara-2',
  rating: '4.9',
  reviewCount: '73',
  googleReviewCount: '27',
  yelpReviewCount: '46',
  yearEstablished: 2001,
  tagline: 'Collision Repair Specialists \u2014 Back to OEM Standards',
  languages: ['English', 'Korean', 'Vietnamese'],
  manager: 'Allen P.',
  values: ['Asian-owned', 'LGBTQ+ friendly', 'Open to All'],
}
